import type { FC, ReactElement } from 'react';

import { useGameConfig } from '../../config/GameConfigProvider';
import { useFeature } from '../../services/features/reactBindings/hooks';
import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { Modal } from '../modal/modal/Modal';

export const BetLimitModalConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const { betLimitContent } = useGameConfig();
  const newLayout = useFeature('newLayout');

  const open = useHeaderSlice.getCoreBetLimitsOpen();
  const heightAdjustment = useConfigSlice.playAreaDimensions()?.height;

  return (
    <Modal
      data-testid="bet-limits-modal"
      draggable
      fullScreenNoClose
      heightAdjustment={heightAdjustment}
      newLayout={newLayout}
      onClose={() => dispatch(headerActions.setBetLimitsOpen(!open))}
      open={open}
      originX="start"
      tk="MENU_PAYOUTS_LIMITS"
    >
      {betLimitContent}
    </Modal>
  );
};
